module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/sp/common/icon_sheet-f16c95251e098dcf5f79f4577275fb26.png";